import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Script = () => {
  useEffect(() => {
    AOS.init({
      easing: "ease-out-cubic",
    });
  }, []);
  return <></>;
};

export default Script;
